export default __webpack_public_path__ + "static/media/icon-announcement-outline.ca69114c.svg";